export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_02.9a83be71.jpg";